// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'entity.page.title': 'Contacts',
    'entity-csv.page.import.title': 'Import Contacts',
    'entity.page.archive.title': 'Archived Contacts',
    'entity.page.search_results': 'Search Results',
    'entity.page.create.title': 'Create New Person or Place',
    'entity.page.search.title': 'Find Person or Place',
    'entity.page.edit.title': 'Edit Person or Place',
    'entity.page.all': 'All',

    'entity.button.cancel': 'Cancel',
    'entity.button.select': 'Select',
    'entity.button.find': 'Find Person or Place',
    'entity.button.search': 'Apply',
    'entity.button.create': 'Save Person or Place',
    'entity.button.new': 'New Person or Place',
    'entity.button.save': 'Save Changes',
    'entity.button.archive': 'Archive',
    'entity.button.delete': 'Permanently Delete',
    'entity.button.edit': 'Edit',
    'entity.button.restore': 'Restore',
    'entity.button.reset': 'Reset',
    'entity.button.view': 'View',
    'entity-csv.button.import': 'Import',

    'entity.placeholder.search': 'Search for Contacts',

    'entity.link.create_first_entity': 'Click here to create your first Person or Place',
    'entity.link.entities': ' Return to Contacts',
    'entity.link.archive': 'Archived Contacts',
    'entity.link.retry': 'Click here to retry',

    'entity.checkbox.all': 'Check All',
    'entity.checkbox.actions_label': 'with selected',

    'entity.label.is_public': 'Is Public',
    'entity.label.is_tax_exempt': 'Is Tax Exempt',
    'entity.label.account_balance': 'Account Balance',
    'entity.label.add_new_contact': 'Add New Person or Place',

    'entity.label.entity_type_name': 'Contact Type',

    'entity.label.is_individual': 'Individual',

    'entity.label.is_company': 'Company',

    'entity.label.entity_name': 'Contact Name',

    'entity.label.company_name': 'Company Name',

    'entity.label.first_name': 'First Name',

    'entity.label.last_name': 'Last Name',

    'entity.label.address_line_1': 'Address Line 1',

    'entity.label.address_line_2': 'Address Line 2',

    'entity.label.address_line_3': 'Address Line 3',

    'entity.label.province': 'Province',

    'entity.label.postal_code': 'Postal Code',

    'entity.label.country_name': 'Country',

    'entity.label.email_address': 'Email Address',

    'entity.label.telephone_number_1': 'Telephone Number 1',

    'entity.label.telephone_number_2': 'Telephone Number 2',

    'entity.label.note': 'Note',

    'entity.label.from__created_at': 'From created at',
    'entity.label.to__created_at': 'To created at',
    'entity.label.created_at': 'Created At',

    'entity.label.from__updated_at': 'From updated at',
    'entity.label.to__updated_at': 'To updated at',
    'entity.label.updated_at': 'Updated At',

    'entity.label.from__deleted_at': 'From deleted at',
    'entity.label.to__deleted_at': 'To deleted at',
    'entity.label.deleted_at': 'Deleted At',

    'entity.label.status': 'Status',

    'entity.label.entity_tax_classification_name': 'Tax Classification',

    'entity.label.default_term': 'Default Terms',
    'entity.label.default_currency': 'Default Currency',

    'entity.term': 'Due on receipt | {count} days',

    'entity.sort.field_label': 'Field',
    'entity.sort.direction_label': 'Direction',
    'entity.sort.direction_ascending': 'Ascending',
    'entity.sort.direction_descending': 'Descending',

    'entity.modal.title.entity_archive': 'Archive Person or Place',
    'entity.modal.title.entity_delete_permanently': 'Delete Person or Place',
    'entity.modal.title.entity_restore': 'Restore Person or Place',

    'entity.modal.message.entity_archive': 'Are you sure that you want to move this person or place to the archive? | Are you sure that you want to move these persons or places to the archive?',
    'entity.modal.message.entity_delete_permanently':
        'Are you sure that you want to permanently delete this person or place? This action cannot be undone. | Are you sure that you want to permanently delete these persons or places? This action cannot be undone.',
    'entity.modal.message.entity_restore': 'Are you sure that you want to restore this person or place? | Are you sure that you want to restore these persons or places?',

    'entity.success.message.entity_created': 'Your person or place has been created',
    'entity.success.message.entity_updated': 'Your person or place has been updated',
    'entity.success.message.entity_restored': 'Your person or place has been restored | All selected persons or places were restored',
    'entity.success.message.entity_deleted': 'Your person or place has been permanently deleted | All selected persons or places were permanently deleted',
    'entity.success.message.archived_entities': 'Your person or place was moved to the archive | All selected persons or places were moved to the archive',

    'entity.error.message.archived_entities': 'This person or place was already moved to the archive | These persons or places were already moved to the archive',
    'entity.error.message.entity_deleted': 'This person or place was already permanently deleted | These persons or places were already permanently deleted',
    'entity.error.message.entity_restored': 'This person or place was already restored | These persons or places were already restored',
    'entity.error.message.error_loading_page': 'Sorry, there was an error loading person or place.| Sorry, there was an error loading persons or places.',

    'entity.message.search.no_archived_entities': "You haven't archived any persons or places as yet.",

    'entity.error.message.error_importing_team_members': 'Sorry, there was an error uploading your team members. Please check your file and try again.',

    'entity.message.search.no_archived_team_members': "You haven't archived any team any members as yet.",

    'entity-csv.page.note': 'Please ensure to click the check mark if your file already includes headers.',
    'entity-csv.page.skip_matching.label': 'Skip rows that match an existing contact',
    'entity-csv.page.skip_matching.help':
        'A row is skipped when a contact of the same type already has the same email address and name. Contacts who only share an email address, such as family members, are still imported. Skipped rows are listed in the email you receive when the import finishes.',
    'entity-csv.page.required_fields': 'Required Fields',
    'entity-csv.page.all_fields': 'All Fields',
    'entity-csv.page.message.column_names': 'Column names are in the first line',
    'entity-csv.page.message.field': 'Field',
    'entity-csv.page.message.column': 'Column',

    'entity-csv.error.message.csv_is_blank': "It looks like the CSV file is empty. No worries — just take a moment to double-check your file, and feel free to try again whenever you're ready!",
    'entity-csv.page.instructions': 'Below are two sample files which will show the fields used in the import process.',

    'entity-csv.error.message.invalid_file_type': 'Sorry, we only support CSV files. Please try again with a CSV file.',
};
